export const ENNEAGRAM_QUESTIONS = [
  {
    id: 'q1',
    question:
      "When you're at your worst — stressed, overwhelmed, or backed into a corner — what's the feeling that hits you hardest?",
    options: [
      {
        letter: 'A',
        text: 'A sense that everything is falling apart and no one else sees it or is stepping up',
      },
      {
        letter: 'B',
        text: "A fear that you're not being seen or appreciated for what you bring",
      },
      {
        letter: 'C',
        text: "A deep frustration that people aren't doing things the right way",
      },
      {
        letter: 'D',
        text: 'A feeling of being trapped, like your options are shrinking',
      },
      {
        letter: 'E',
        text: 'A sense of emptiness or disconnection, like something essential is missing',
      },
    ],
    scoring: {
      A: { 8: 2, 1: 1 },
      B: { 2: 2, 3: 1 },
      C: { 1: 2, 6: 1 },
      D: { 7: 2, 5: 1 },
      E: { 4: 2, 9: 1 },
    },
    weight: 'HIGH',
    tiebreaker: 2,
  },
  {
    id: 'q2',
    question:
      "When you walk into a room full of people — a meeting, a party, a new group — what's your default internal experience?",
    options: [
      {
        letter: 'A',
        text: "I'm scanning for who's in charge, who matters, and where I fit in the power dynamic",
      },
      {
        letter: 'B',
        text: "I'm reading the energy — picking up on tensions, moods, what's unspoken",
      },
      {
        letter: 'C',
        text: "I'm figuring out what's expected of me and how to make a good impression",
      },
      {
        letter: 'D',
        text: "I'm genuinely curious about the people, but I also feel a pull to hold back and observe",
      },
      {
        letter: 'E',
        text: "I'm thinking about how to be helpful or connect with someone who seems like they need it",
      },
    ],
    scoring: {
      A: { 3: 2, 8: 1 },
      B: { 2: 2, 4: 1 },
      C: { 6: 2, 3: 1 },
      D: { 5: 2, 4: 1 },
      E: { 9: 2, 2: 1 },
    },
    weight: 'MEDIUM',
    tiebreaker: null,
  },
  {
    id: 'q3',
    question:
      'What do you secretly fear other people would think if they really knew you?',
    options: [
      {
        letter: 'A',
        text: "That I'm not as competent or put-together as I appear",
      },
      {
        letter: 'B',
        text: "That I'm too much — too intense, too different, too complicated",
      },
      {
        letter: 'C',
        text: "That I'm actually selfish underneath the help I give",
      },
      {
        letter: 'D',
        text: "That I don't really need anyone, and that makes me cold",
      },
      {
        letter: 'E',
        text: "That I'm not as strong or decisive as people assume I am",
      },
    ],
    scoring: {
      A: { 3: 2, 1: 1 },
      B: { 4: 2, 8: 1 },
      C: { 2: 3 },
      D: { 5: 3 },
      E: { 6: 2, 9: 1 },
    },
    weight: 'HIGH',
    tiebreaker: 3,
  },
  {
    id: 'q4',
    question:
      "What drives you most in your work and life — the thing that, if you're honest, you're always chasing?",
    options: [
      {
        letter: 'A',
        text: 'Mastery — being deeply knowledgeable and capable in my domain',
      },
      {
        letter: 'B',
        text: "Significance — making an impact that's uniquely mine, not interchangeable",
      },
      {
        letter: 'C',
        text: "Security — building something solid that can't be easily taken away",
      },
      {
        letter: 'D',
        text: 'Achievement — being recognized as successful and effective',
      },
      {
        letter: 'E',
        text: "Authenticity — living and working in a way that's true to who I really am",
      },
    ],
    scoring: {
      A: { 5: 2, 1: 1 },
      B: { 4: 2, 8: 1 },
      C: { 6: 3 },
      D: { 3: 3 },
      E: { 4: 2, 9: 1 },
    },
    weight: 'HIGH',
    tiebreaker: null,
  },
  {
    id: 'q5',
    question:
      "In your closest relationships, what's the pattern that keeps showing up — the thing that causes the most friction?",
    options: [
      {
        letter: 'A',
        text: "I give a lot and then resent that it's not reciprocated equally",
      },
      {
        letter: 'B',
        text: 'I withdraw when things get too emotionally demanding or chaotic',
      },
      {
        letter: 'C',
        text: 'I push people to grow or improve, and they experience it as criticism',
      },
      {
        letter: 'D',
        text: "I feel misunderstood — like people appreciate what I do but don't really get me",
      },
      {
        letter: 'E',
        text: "I take charge and others feel steamrolled, even when I'm trying to help",
      },
    ],
    scoring: {
      A: { 2: 3 },
      B: { 5: 2, 9: 1 },
      C: { 1: 3 },
      D: { 4: 3 },
      E: { 8: 3 },
    },
    weight: 'HIGH',
    tiebreaker: null,
  },
  {
    id: 'q6',
    question:
      "When you accomplish something significant — a big win at work, a breakthrough — what's the feeling that follows?",
    options: [
      {
        letter: 'A',
        text: "Satisfaction, but it fades fast and I'm already thinking about the next thing",
      },
      {
        letter: 'B',
        text: "Pride, but also a nagging sense that people are celebrating the result, not the real me behind it",
      },
      {
        letter: 'C',
        text: 'Relief more than joy — like I avoided failure rather than achieved something',
      },
      {
        letter: 'D',
        text: 'I want to share it and be acknowledged, but I also feel uncomfortable asking for attention',
      },
      {
        letter: 'E',
        text: 'It feels good, but I quickly start comparing it to what others have done',
      },
    ],
    scoring: {
      A: { 3: 2, 7: 1 },
      B: { 4: 3 },
      C: { 6: 2, 1: 1 },
      D: { 2: 2, 9: 1 },
      E: { 3: 2, 5: 1 },
    },
    weight: 'MEDIUM',
    tiebreaker: null,
  },
  {
    id: 'q7',
    question:
      "When you're alone with nothing to do — no work, no family obligations, no distractions — what happens internally?",
    options: [
      {
        letter: 'A',
        text: 'I feel restless and start looking for something to engage with or plan',
      },
      {
        letter: 'B',
        text: 'I actually love it — solitude is where I recharge and feel most like myself',
      },
      {
        letter: 'C',
        text: "A heaviness or sadness creeps in that I can't always explain",
      },
      {
        letter: 'D',
        text: 'I feel guilty, like I should be doing something productive or useful for someone',
      },
      {
        letter: 'E',
        text: 'My mind races — I start anticipating problems or worst-case scenarios',
      },
    ],
    scoring: {
      A: { 7: 2, 3: 1 },
      B: { 5: 2, 4: 1 },
      C: { 4: 2, 9: 1 },
      D: { 1: 2, 2: 1 },
      E: { 6: 3 },
    },
    weight: 'MEDIUM',
    tiebreaker: null,
  },
  {
    id: 'q8',
    question:
      'Think about a time someone close to you was struggling. What was your instinct?',
    options: [
      {
        letter: 'A',
        text: 'Figure out the solution and tell them what they need to do',
      },
      {
        letter: 'B',
        text: 'Drop everything and be there for them — their pain becomes my priority',
      },
      {
        letter: 'C',
        text: 'Listen and empathize, but I also need to protect my own energy',
      },
      {
        letter: 'D',
        text: "Offer perspective — help them see the bigger picture so they don't spiral",
      },
      {
        letter: 'E',
        text: "I feel their pain almost physically, like it's happening to me too",
      },
    ],
    scoring: {
      A: { 8: 2, 1: 1 },
      B: { 2: 3 },
      C: { 5: 2, 4: 1 },
      D: { 3: 2, 7: 1 },
      E: { 9: 2, 2: 1 },
    },
    weight: 'MEDIUM',
    tiebreaker: null,
  },
  {
    id: 'q9',
    question:
      "Which of these statements feels most painfully true about you — the one that makes you a little uncomfortable?",
    options: [
      {
        letter: 'A',
        text: "I shape-shift depending on who I'm with — I know how to become what each situation needs",
      },
      {
        letter: 'B',
        text: "I secretly believe I'm more capable than most people around me, and it frustrates me when they can't keep up",
      },
      {
        letter: 'C',
        text: "I help people partly because it makes me feel essential — and I don't love admitting that",
      },
      {
        letter: 'D',
        text: "I perform confidence, but underneath I'm not sure I've figured out who I really am apart from my roles",
      },
      {
        letter: 'E',
        text: "I hold people to standards I'd never openly state, and I judge them when they fall short",
      },
    ],
    scoring: {
      A: { 3: 3 },
      B: { 8: 2, 1: 1 },
      C: { 2: 3 },
      D: { 9: 2, 6: 1 },
      E: { 1: 2, 5: 1 },
    },
    weight: 'HIGHEST',
    tiebreaker: 1,
  },
  {
    id: 'q10',
    question: 'If you could only fix one thing about yourself, which would it be?',
    options: [
      {
        letter: 'A',
        text: 'I wish I could stop needing external validation to feel like I matter',
      },
      {
        letter: 'B',
        text: 'I wish I could let people struggle without feeling compelled to step in',
      },
      {
        letter: 'C',
        text: "I wish I could rest without feeling like I'm falling behind",
      },
      {
        letter: 'D',
        text: 'I wish I could express my real needs without feeling like it makes me weak or burdensome',
      },
      {
        letter: 'E',
        text: "I wish I could stop performing and just be without worrying about how I'm perceived",
      },
    ],
    scoring: {
      A: { 2: 2, 3: 1 },
      B: { 2: 2, 8: 1 },
      C: { 3: 2, 7: 1 },
      D: { 9: 2, 2: 1 },
      E: { 3: 2, 4: 1 },
    },
    weight: 'HIGH',
    tiebreaker: null,
  },
];

export const TYPE_LABELS = {
  '1w9': 'The Idealist',
  '1w2': 'The Advocate',
  '2w1': 'The Servant',
  '2w3': 'The Host',
  '3w2': 'The Charmer',
  '3w4': 'The Professional',
  '4w3': 'The Aristocrat',
  '4w5': 'The Bohemian',
  '5w4': 'The Iconoclast',
  '5w6': 'The Problem Solver',
  '6w5': 'The Defender',
  '6w7': 'The Buddy',
  '7w6': 'The Entertainer',
  '7w8': 'The Maverick',
  '8w7': 'The Commander',
  '8w9': 'The Bear',
  '9w8': 'The Referee',
  '9w1': 'The Dreamer',
};

export const WING_ADJACENTS = {
  1: [9, 2],
  2: [1, 3],
  3: [2, 4],
  4: [3, 5],
  5: [4, 6],
  6: [5, 7],
  7: [6, 8],
  8: [7, 9],
  9: [8, 1],
};

export function scoreAssessment(answers) {
  const scores = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 };

  ENNEAGRAM_QUESTIONS.forEach((q) => {
    const answer = answers[q.id];
    if (!answer) return;
    const points = q.scoring[answer];
    if (!points) return;
    Object.entries(points).forEach(([type, pts]) => {
      scores[parseInt(type)] += pts;
    });
  });

  let primaryType = 1;
  let highScore = 0;
  Object.entries(scores).forEach(([type, score]) => {
    if (score > highScore) {
      highScore = score;
      primaryType = parseInt(type);
    }
  });

  const adjacents = WING_ADJACENTS[primaryType];
  const wing =
    scores[adjacents[0]] >= scores[adjacents[1]] ? adjacents[0] : adjacents[1];

  const designation = `${primaryType}w${wing}`;
  const label = TYPE_LABELS[designation] || `Type ${primaryType}`;

  const sortedScores = Object.values(scores).sort((a, b) => b - a);
  const gap = sortedScores[0] - sortedScores[1];
  const confidence = gap >= 5 ? 'high' : gap >= 3 ? 'moderate' : 'low';

  return {
    enneagram_type: primaryType,
    wing,
    full_designation: designation,
    label,
    scores,
    confidence,
  };
}
